import styled from 'styled-components';
import { Typography } from 'antd';
import { COLORS } from '@/utils/static';
import { BREAKPOINTS } from '@/ui';

export const OptionCard = ({
  icon,
  title = '',
  onClick,
  iconSize = 98,
  maxWidth = 264,
  gap = 25
}) => {
  return (
    <Container onClick={onClick} $maxWidth={maxWidth} $gap={gap}>
      <Icon src={icon} alt='' $width={iconSize} $height={iconSize} />

      <Title level={4}>{title}</Title>
    </Container>
  );
};

const Container = styled.div`
  padding: 20px 55px;
  width: 100%;
  ${({ $maxWidth }) => ($maxWidth ? `max-width: ${$maxWidth}px;` : '')}
  height: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ $gap }) => `${$gap}px`};
  background: ${COLORS.white};
  box-shadow: 0px 12px 24px 0px rgba(0, 111, 255, 0.2);
  cursor: pointer;
  box-sizing: border-box;

  @media (max-width: ${BREAKPOINTS.sm}px) {
    flex-direction: row;
    gap: 18px;
    padding: 20px;
    height: unset;
    justify-content: flex-start;
  }
`;

const Icon = styled.img`
  ${({ $width }) => `width:${$width}px`};
  ${({ $height }) => `height:${$height}px`};

  @media (max-width: ${BREAKPOINTS.sm}px) {
    width: 55px;
    height: 55px;
  }
`;

const Title = styled(Typography.Title)`
  color: ${COLORS.default} !important;
  font-weight: 400 !important;
  text-align: center !important;

  @media (max-width: ${BREAKPOINTS.sm}px) {
    font-size: 14px !important;
  }
`;
